import React from 'react';
import ReactDOM from 'react-dom/client';
import ETFRadar from './App';
import ErrorBoundary from './ErrorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <ETFRadar />
    </ErrorBoundary>
  </React.StrictMode>
);
